import { useState } from 'react';
import type { Coordinates, ManualObstacle, ObstacleKind } from '@freedom/shared';
import { X } from 'lucide-react';
import { createClientId } from './client-id';

export function ObstacleDialog({ coordinates, onClose, onCreate }: { coordinates: Coordinates; onClose(): void; onCreate(obstacle: ManualObstacle): void }): React.JSX.Element {
  const [name, setName] = useState('Ручное препятствие');
  const [kind, setKind] = useState<ObstacleKind>('manual');
  const [heightM, setHeightM] = useState(12);

  const submit = (event: React.FormEvent): void => {
    event.preventDefault();
    onCreate({ id: createClientId(), name: name.trim(), kind, coordinates, heightM });
    onClose();
  };

  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={onClose}>
      <section className="dialog obstacle-dialog" role="dialog" aria-modal="true" aria-labelledby="obstacle-title" onMouseDown={(event) => event.stopPropagation()}>
        <div className="dialog-heading"><div><span className="eyebrow">{coordinates.lat.toFixed(5)}, {coordinates.lon.toFixed(5)}</span><h2 id="obstacle-title">Новое препятствие</h2></div><button className="icon-button" type="button" aria-label="Закрыть" onClick={onClose}><X size={18} /></button></div>
        <form className="dialog-form" onSubmit={submit}>
          <label><span>Название</span><input value={name} onChange={(event) => setName(event.target.value)} minLength={2} maxLength={120} required /></label>
          <label><span>Тип</span><select value={kind} onChange={(event) => setKind(event.target.value as ObstacleKind)}><option value="manual">Произвольное</option><option value="building">Здание</option><option value="tower">Башня</option><option value="tree">Дерево</option><option value="vegetation">Лесополоса</option></select></label>
          <label><span>Высота над поверхностью, м</span><input type="number" min="0.5" max="500" step="0.5" value={heightM} onChange={(event) => setHeightM(Number(event.target.value))} required /></label>
          <button className="primary-action" type="submit">Добавить препятствие</button>
        </form>
        <p className="dialog-note">Ручная высота имеет высокий приоритет, но используется через `max(surface, obstacle)`, без повторного добавления к DSM.</p>
      </section>
    </div>
  );
}
